// DEPLOY: /var/www/woody.wtf/frontend/src/components/AnalysisToggle.js
// The ~300-word AI analysis under an announcement's summary (announcements.analysis,
// analyse_announcements.py): a small "Analysis" link that expands it in place.
// Renders nothing for announcements analysed before the analysis existed.
// Used by the Announcements and Company pages.
import React, { useState } from 'react';

export default function AnalysisToggle({ text }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  const toggle = e => { e.stopPropagation(); setOpen(o => !o); };
  return (
    <div style={{ marginTop: '6px' }}>
      <span onClick={toggle} style={{ fontSize: '12px', fontWeight: 500, color: 'var(--accent)', cursor: 'pointer', userSelect: 'none' }}>
        {open ? 'Hide analysis ▴' : 'Analysis ▾'}
      </span>
      {open && (
        <div style={{ marginTop: '6px', padding: '10px 12px', fontSize: '13px', lineHeight: 1.6, whiteSpace: 'pre-wrap',
                      color: 'var(--text)', background: 'var(--accent-faint)', borderLeft: '2px solid var(--accent)',
                      borderRadius: '0 var(--radius) var(--radius) 0' }}>
          {text}
        </div>
      )}
    </div>
  );
}
